export default __webpack_public_path__ + "static/media/imagewhite.de9733bb.svg";